<div class="actions" fxLayout="row" fxLayoutAlign="space-between center">
  <div class="buttons">
    <div
      fxLayout="row"
      style="height: 30px"
      fxLayoutAlign="space-between space-between"
    >
      <h1 style="padding-left: 10px">
        {{ "پرینت شماره: " + order.id | digitsEnToFa }}
      </h1>
    </div>

    <button mat-button color="primary" class="download-btn">
      <a
        class="download-link"
        download="true"
        [href]="getBaseUrl() + '/files/download/pdf/' + mainFile.id"
      ></a>
      <span>دانلود فایل</span>
      <jam-icon name="download"></jam-icon>
    </button>

    <button mat-button>
      <span>پرینت فاکتور</span>
      <jam-icon name="document"></jam-icon>
    </button>

    <button mat-button (click)="openAnnouncePriceDialog()">
      <span>اعلام قیمت</span>
      <jam-icon color="warn" name="arrow-square-up"></jam-icon>
    </button>
  </div>

  <div class="icon-buttons">
    <button mat-icon-button mat-dialog-close color="warn">
      <jam-icon name="close"></jam-icon>
    </button>
  </div>
</div>

<section class="thesis-edit">
  <shared-file-placeholder
    id="coverImagePlaceholder"
    (onFileSelect)="selectFile('cover', $event)"
    name="coverImage"
    [selectable]="false"
    [immediateUpload]="true"
    #coverImageFilePlaceholder
    placeholder="فایل ویرایش شده"
    urlName="uploadImages"
    fxFlex="65"
    fxFlex.lt-md="100"
    [layouts]="[50, 50]"
  ></shared-file-placeholder>
</section>
<div
  class="admin-document-preview-container"
  fxLayout="row wrap"
  fxLayoutAlign="space-between start"
>
  <div class="main-holder" fxFlex="100">
    <mat-card class="file-content">
      <mat-card-content>
        <div
          class="info-blocks"
          fxLayout="row wrap"
          fxLayoutAlign="space-between stretch"
        >
          <div
            fxFlex="32"
            class="info-block"
            fxFlex.lt-sm="100"
            fxLayout="column"
          >
            <jam-icon class="user-icon" [size]="100" name="printer"></jam-icon>
            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">اندازه کاغذ</div>
              <div class="data" fxFlex="50">{{ getOrderSize() }}</div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">نوع چاپ</div>
              <div class="data" fxFlex="50">{{ order.type }}</div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">یک رو / دو رو</div>
              <div class="data" fxFlex="50">
                {{ isTwoSided ? "دو رو" : "یک رو" }}
              </div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">تعداد برگ</div>
              <div class="data" fxFlex="50">
                {{ order.pageCount }}
              </div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">صحافی یا کاور</div>
              <div class="data" fxFlex="50">
                {{ order.binding?.name || "کاور" }}
              </div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">رنگ طلق</div>
              <div class="data" fxFlex="50">
                {{ "سبز" }}
              </div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">تعداد نسخه</div>
              <div class="data" fxFlex="50">
                {{ order.copiesNumber }}
              </div>
            </div>
          </div>

          <div
            class="info-block"
            fxFlex="32"
            fxFlex.lt-sm="100"
            fxLayout="column"
          >
            <jam-icon class="user-icon" [size]="100" name="file"></jam-icon>
            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">شماره فایل</div>
              <div
                class="data"
                fxFlex="50"
                class="ltr"
                style="text-align: center"
              >
                {{ order.hash }}
              </div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">نام فایل</div>
              <div class="data" fxFlex="50">{{ mainFile.originalname }}</div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">تاریخ ثبت</div>
              <div class="data" fxFlex="50">
                {{ getDate() | jdate : "d mmm yyyy" | digitsEnToFa }}
              </div>
            </div>
            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">زمان ثبت</div>
              <div class="data" fxFlex="50">
                {{ getDate() | jdate : "h:M t" | digitsEnToFa }}
              </div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">کد پیگیری</div>
              <div class="data" fxFlex="50">
                {{ order.hash | json }}
              </div>
            </div>
          </div>

          <div
            class="info-block"
            fxFlex="32"
            fxFlex.lt-sm="100"
            fxLayout="column"
          >
            <jam-icon class="user-icon" [size]="100" name="user"></jam-icon>
            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">شماره کاربری</div>
              <div class="data" fxFlex="50" dir="ltr">
                {{ order.user?.id! }}
              </div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">نام کاربری</div>
              <div class="data" fxFlex="50">{{ order.user?.fullName }}</div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">تلفن یا ایمیل</div>
              <div class="data" fxFlex="50">
                {{ order.user?.phone || order.user?.email }}
              </div>
            </div>
          </div>

          <div
            class="info-block"
            fxFlex="66"
            fxFlex.lt-sm="100"
            fxLayout="column"
          >
            <jam-icon class="user-icon" [size]="100" name="layers-f"></jam-icon>
            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="20">رنگی</div>
              <div class="data" fxFlex="75" dir="ltr">
                <mat-chip-listbox *ngIf="colorfulBlocks().length > 0">
                  <mat-chip
                    class="range-item"
                    *ngFor="let item of colorfulBlocks()"
                  >
                    <strong *ngIf="+item.start === +item.end">{{
                      item.start | digitsEnToFa
                    }}</strong>
                    <strong *ngIf="+item.start !== +item.end">{{
                      item.start + "-" + item.end | digitsEnToFa
                    }}</strong>
                  </mat-chip>
                </mat-chip-listbox>
                <span *ngIf="!colorfulBlocks().length">-</span>
              </div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="20">نیمه رنگی</div>
              <div class="data" fxFlex="75">
                <mat-chip-listbox *ngIf="halfColorfulBlocks.length > 0">
                  <mat-chip
                    class="range-item"
                    *ngFor="let item of halfColorfulBlocks"
                  >
                    <strong *ngIf="+item.start === +item.end">{{
                      item.start | digitsEnToFa
                    }}</strong>
                    <strong *ngIf="+item.start !== +item.end">{{
                      item.start + "-" + item.end | digitsEnToFa
                    }}</strong>
                  </mat-chip>
                </mat-chip-listbox>
                <span *ngIf="!halfColorfulBlocks.length">-</span>
              </div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="20">سیاه و سفید</div>
              <div class="data" fxFlex="75">
                <mat-chip-listbox *ngIf="blackWhiteBlocks.length > 0">
                  <mat-chip
                    class="range-item"
                    *ngFor="let item of blackWhiteBlocks"
                  >
                    <strong *ngIf="+item.start === +item.end">{{
                      item.start | digitsEnToFa
                    }}</strong>
                    <strong *ngIf="+item.start !== +item.end">{{
                      item.start + "-" + item.end | digitsEnToFa
                    }}</strong>
                  </mat-chip>
                </mat-chip-listbox>
                <span *ngIf="blackWhiteBlocks.length <= 0">-</span>
              </div>
            </div>
          </div>

          <div
            class="info-block"
            fxFlex="32"
            fxFlex.lt-sm="100"
            fxLayout="column"
          >
            <jam-icon class="user-icon" [size]="100" name="coin"></jam-icon>
            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">مبلغ سفارش</div>
              <div class="data" fxFlex="50" dir="ltr">
                {{ order.price | irc : "T" | digitsEnToFa }}
              </div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">نحوه پرداخت</div>
              <div class="data" fxFlex="50">{{ "اینترنتی" }}</div>
            </div>

            <div
              class="block"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div class="title" fxFlex="50">کد پیگیری</div>
              <div class="data" fxFlex="50">
                {{ order.hash }}
              </div>
            </div>
          </div>

          <div class="info-block" fxFlex="100" fxLayout="row">
            <div
              class="block description"
              fxFlex="100"
              fxLayout="row"
              fxLayoutAlign="space-between stretch"
            >
              <div class="title" fxFlex="20">توضیحات</div>

              <div class="data" fxFlex="75">
                <p>{{ mainFile.info || "توضیحاتی درج نشد" }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="preview-pages"></div>
        <div class="description"></div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div class="admin-orders-container" [ngSwitch]="type"></div>
